export default "__VITE_ASSET__DrIHEkRz__"